import React, { useRef } from "react";
import { Color } from "#shared/theme";
import { useMarketsChartAnimationMobile, useNumberFormat } from "#hooks";
import { SvgText, SvgTextSmall } from "#ui";
import { chartMobileGlobalMarketsDuration } from "#constants";
import { ChartMarketPropsMobile } from "./chartProps";

export const America: React.FC<ChartMarketPropsMobile> = (props) => {
  const currentPathRef = useRef<SVGLineElement>(null);
  const contentRef = useRef<SVGGElement>(null);
  const lineRef = useRef<SVGPolylineElement>(null);
  const topLineRef = useRef<SVGLineElement>(null);
  const pathLength = useMarketsChartAnimationMobile({
    ...props,
    currentPathRef,
    contentRef,
    lineRef,
    topLineRef,
    animationDuration: chartMobileGlobalMarketsDuration,
  });
  return (
    <g fill="none">
      <line ref={currentPathRef} stroke={Color.BlackLight} strokeWidth="9" x1="137.5" y1="322" x2="137.5" y2="322" />
      <line ref={topLineRef} stroke={Color.White} strokeWidth="9" x1="137.5" y1="322" x2="137.5" y2="322" />
      <polyline
        ref={lineRef}
        stroke={Color.White}
        strokeMiterlimit="9"
        points="284,207.5 210,207.5 142,322 133,322"
        strokeDashoffset={pathLength}
        strokeDasharray={pathLength}
      />

      <SvgText ref={contentRef} alignEnd>
        <SvgTextSmall>
          <text fill={Color.BlackLight} transform="matrix(1 0 0 1 284 199.7695)" fontSize="10">
            {props.labels?.labels.america}
          </text>
        </SvgTextSmall>
        <text transform="matrix(1 0 0 1 284 183.666)" fontSize="28">
          {useNumberFormat(props.currentValue)}
        </text>
      </SvgText>
    </g>
  );
};
